import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _wrapNativeSuper from "@babel/runtime-corejs2/helpers/esm/wrapNativeSuper";
export var SessionNotFoundError = /*#__PURE__*/function (_Error) {
  _inherits(SessionNotFoundError, _Error);

  var _super = _createSuper(SessionNotFoundError);

  function SessionNotFoundError() {
    _classCallCheck(this, SessionNotFoundError);

    return _super.call(this, 'SessionNotFoundError');
  }

  return SessionNotFoundError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWJzL3Nlc3Npb24tbm90LWZvdW5kLWVycm9yLnRzIl0sIm5hbWVzIjpbIlNlc3Npb25Ob3RGb3VuZEVycm9yIiwiRXJyb3IiXSwibWFwcGluZ3MiOiI7Ozs7QUFBQSxXQUFhQSxvQkFBYjtBQUFBOztBQUFBOztBQUNFLGtDQUFjO0FBQUE7O0FBQUEsNkJBQ04sc0JBRE07QUFFYjs7QUFISDtBQUFBLGlDQUEwQ0MsS0FBMUMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgY2xhc3MgU2Vzc2lvbk5vdEZvdW5kRXJyb3IgZXh0ZW5kcyBFcnJvciB7XG4gIGNvbnN0cnVjdG9yKCkge1xuICAgIHN1cGVyKCdTZXNzaW9uTm90Rm91bmRFcnJvcicpO1xuICB9XG59XG4iXX0=